import { omit } from "ramda";
import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";
import { toFormData } from "core/utils";

export const editProfile = createApi({
  name: types.UPDATE_PROFILE,
  request: ({ body }) =>
    requestApi({
      path: "/profile/users/current/",
      headers: omit(["content-type"]),
      body: toFormData(body),
      method: "PATCH",
      config: {
        stringify: false
      }
    })
});

export const updateAvatar = createApi({
  name: types.UPDATE_AVATAR,
  request: ({ photo }) =>
    requestApi({
      path: "/profile/users/current/",
      headers: omit(["content-type"]),
      body: toFormData({ photo }),
      method: "PATCH",
      config: {
        stringify: false
      }
    })
});

export const updateResume = createApi({
  name: types.UPDATE_RESUME,
  request: ({ body }) =>
    requestApi({
      path: "/profile/user-resume/current/",
      method: "PUT",
      headers: omit(["content-type"]),
      body: toFormData(body),
      config: {
        stringify: false
      }
    })
});

export const getCurrentResume = createApi({
  name: types.CURRENT_RESUME,
  request: () =>
    requestApi({
      path: "/profile/user-resume/current/",
      method: "GET"
    })
});



// WEBPACK FOOTER //
// ./src/modules/user/profile/api.js